import './App.css';
import './Theme/common.css';
import { Routes, Route } from 'react-router-dom';
import FullPortfolio from './Pages/index.js';


function App() {
  return (
    <Routes>
      <Route path="/" element={<FullPortfolio /> } />
      
    </Routes>
  );
}

export default App;
